import { Button, Drawer, DrawerOverlay, Flex } from '@chakra-ui/react'
import { PlusIcon } from '@heroicons/react/16/solid'
import Page from 'components/Page'
import { SeatBalanceOutletProvider } from 'modules/Seats/SeatBalances/SeatBalanceOutlet'
import SeatSnapshotInspector from 'modules/Seats/SeatEvents/Inspector/SeatSnapshotInspector'
import { SeatSnapshotsMagicTable } from 'modules/Seats/SeatEvents/SeatEventsMagicTable'
import { SeatTypeProvider } from 'modules/Seats/SeatMetric'
import { useNavigate, useSearchParams, useParams } from 'react-router-dom'
import { usePersistMagicTableQueryParams } from '@sequencehq/tables'

const ActionButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button
      variant="component-library-primary"
      leftIcon={<PlusIcon width="16px" height="16px" color="inherit" />}
      iconSpacing="4px"
      onClick={onClick}
      data-testid="seatEvents.new"
    >
      New seat event
    </Button>
  )
}

export const SeatSnapshots = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { snapshotId } = useParams()
  const queryParamsString = searchParams.toString()
  const { persistMagicTableQueryParams } = usePersistMagicTableQueryParams()

  return (
    <>
      <Flex flexDirection="column" flex={1}>
        <Flex position="sticky" top={0} height="100vh">
          <Page
            title="Events"
            paddingBottom={0}
            actionElement={
              <ActionButton
                onClick={() =>
                  navigate(
                    `/seat-events/new${
                      queryParamsString ? `?${queryParamsString}` : ''
                    }`
                  )
                }
              />
            }
          >
            <SeatSnapshotsMagicTable />
            {snapshotId && (
              <Drawer
                isOpen
                placement="right"
                onClose={() =>
                  navigate(persistMagicTableQueryParams('/seat-events'))
                }
                variant="sidebar"
                size="lg"
              >
                <DrawerOverlay />
                <SeatSnapshotInspector snapshotId={snapshotId} />
              </Drawer>
            )}
          </Page>
        </Flex>
      </Flex>

      <SeatTypeProvider>
        <SeatBalanceOutletProvider />
      </SeatTypeProvider>
    </>
  )
}

export default SeatSnapshots
